import { axiosClient } from "../axios";
import { getQuery } from "../helper";

const dsrBaseUrl = "/api/esg/dsr";
const enterpriseBaseUrl = "/api/registry/enterprises";

/**
 * Permessi effettivi dell'utente corrente su un'azienda. È un GET: resta accessibile anche a
 * firm in sola lettura.
 */
export function getMyPermissions(enterpriseId) {
  const query = getQuery({ enterpriseId });
  return axiosClient.get(`${dsrBaseUrl}/my-permissions`, query);
}

/**
 * Le tre rotte di gestione sono le stesse per il firm admin e per il ROOT: la firm è risolta
 * dall'azienda in rotta, non dal claim del chiamante.
 */
export function getEnterprisePermissions(enterpriseId) {
  return axiosClient.get(
    `${enterpriseBaseUrl}/${enterpriseId}/dsr-permissions`
  );
}

export function setEnterpriseDefault(enterpriseId, payload) {
  return axiosClient.put(
    `${enterpriseBaseUrl}/${enterpriseId}/dsr-permissions`,
    payload
  );
}

export function setUserOverride(enterpriseId, userId, payload) {
  return axiosClient.put(
    `${enterpriseBaseUrl}/${enterpriseId}/dsr-permissions/users/${userId}`,
    payload
  );
}
